





















import { Component, Mixins, Emit, Prop } from "vue-property-decorator";
import { DeveloperPresentableMixin } from "../../../../base/components/developer/mixins";
import { ModelEditableMixin, PdfStyleDrawableMixin } from "../../../../base/components/system/mixins";
import { PdfViewer } from "../../../../base/components/system/viewers";
import { Separator } from "../../../../base/components/system";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { FormatListViewerDebugTool } from "../../developer";
import { FormatTwoPaneSelector } from "../selectors";

@Component({
  components: {
    FormatTwoPaneSelector,
    PdfViewer,
    Separator,
    FormatListViewerDebugTool,
  }
})
export default class FormatListViewer extends Mixins(ModelEditableMixin, PdfStyleDrawableMixin, DeveloperPresentableMixin) {
  @Prop()
  selectedArchive: EditableFormatSummary;

  data() {
    return {
      selectionOfAllFormats: null as EditableFormatSummary[],
    };
  }
  selectionOfAllFormats: EditableFormatSummary[];
  selectorWidth: number = 1200;
  isEditingFormat: boolean = false;

  get isFormatSelected(): boolean {
    return (this.editingSource !== null);
  }

  get selectedPreviewSource(): string {
    return (!this.selectedArchive || !this.selectedArchive.previewSource)
      ? ""
      : this.selectedArchive.previewSource.source;
  }

  editingFormat(value: boolean): void {
    // フォーマット選択ダイアログ表示中に編集を行われた場合、DialogMixinで回避出来ずPDFが表示されてしまうため暫定対応
    this.isEditingFormat = value;
  }

  handleFolderSelectionChanged(formats: EditableFormatSummary[]): void {
    this.selectionOfAllFormats = formats;
  }

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}

  @Emit("selectedListTabChanged")
  selectedListTabChanged(name: string): void {}
}
